const emptyCartSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_29)">
<path d="M5.25 6.54H22.7962L19.8187 16.1437H7.86L4.24125 2.98125H1.125" stroke="white" stroke-width="2"/>
<path d="M10.125 20.625C10.5392 20.625 10.875 20.2892 10.875 19.875C10.875 19.4608 10.5392 19.125 10.125 19.125C9.71079 19.125 9.375 19.4608 9.375 19.875C9.375 20.2892 9.71079 20.625 10.125 20.625Z" fill="white" stroke="white" stroke-width="2"/>
<path d="M17.625 20.625C18.0392 20.625 18.375 20.2892 18.375 19.875C18.375 19.4608 18.0392 19.125 17.625 19.125C17.2108 19.125 16.875 19.4608 16.875 19.875C16.875 20.2892 17.2108 20.625 17.625 20.625Z" fill="white" stroke="white" stroke-width="2"/>
</g>
<defs>
<clipPath id="clip0_1_29">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>`

const cartSvg = `<svg width="27" height="24" viewBox="0 0 27 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_36)">
<path d="M5.25 6.54H22.7962L19.8187 16.1437H7.86L4.24125 2.98125H1.125" stroke="white" stroke-width="2"/>
<path d="M10.125 20.625C10.5392 20.625 10.875 20.2892 10.875 19.875C10.875 19.4608 10.5392 19.125 10.125 19.125C9.71079 19.125 9.375 19.4608 9.375 19.875C9.375 20.2892 9.71079 20.625 10.125 20.625Z" fill="white" stroke="white" stroke-width="2"/>
<path d="M17.625 20.625C18.0392 20.625 18.375 20.2892 18.375 19.875C18.375 19.4608 18.0392 19.125 17.625 19.125C17.2108 19.125 16.875 19.4608 16.875 19.875C16.875 20.2892 17.2108 20.625 17.625 20.625Z" fill="white" stroke="white" stroke-width="2"/>
</g>
<circle cx="20.5" cy="6.5" r="5.55" fill="#FF4F33" stroke="white" stroke-width="1.9"/>
<defs>
<clipPath id="clip0_1_36">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>`


class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0)
        .finally(() => {
          cartItems.updatePriceCountAndGamification(this.dataset.index)
        });

    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  updatePriceCountAndGamification(line) {
    //update cart count
    const cartCount = Array.from(document.querySelectorAll('.cart-item')).map((item) => item.querySelector('.quantity__input').value).reduce((acc, curr) => Number(acc) + Number(curr), 0);
    const cartCountElement = document.querySelector('.cart-count-container');

    if (cartCountElement && document.getElementById('drawer__heading')) document.getElementById('drawer__heading').style.display = "flex";

    //update cart Icon
    const cartIcon = document.getElementById('cart-icon-bubble');
    cartIcon.innerHTML = cartCount ? cartSvg : emptyCartSvg;

    //update shipping text
    calculateShippingDate()

    //update gamification
    updateGamification()

    this.disableLoading(line);
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
      this.appendShippingText()

    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'))
      .finally(() => {
        this.updatePriceCountAndGamification(event.target.dataset.index)
      });
  }

  appendShippingText() {
    setTimeout(() => {
      const shippingElement = document.querySelector('.shipping-visually-hidden')?.cloneNode(true);
      shippingElement.classList.remove('visually-hidden');
      document.querySelector('.cart-drawer-items')?.appendChild(shippingElement)

    }, 500);
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
        document.querySelectorAll(".js-update").forEach(function (script) {
          eval(script.innerHTML);
          eval(script.innerText);
        })
        if (typeof globalPop != "undefined") {
          globalPop.time = 2000;
          globalPop.run();
        }
      })
      .catch(e => {
        console.error(e);
      }).finally(() => {
        this.updatePriceCountAndGamification()
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  async updateQuantity(line, quantity, name) {
    // this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          // this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (section?.section === "cart-icon-bubble") {
            elementToReplace.innerHTML = emptyCartSvg;
          }
          else {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }

        }));

        // Coment here
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
          document.querySelector('.main-drawer__header').style.display = "flex";

        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))

        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          document.querySelector('.main-drawer__header').style.display = "flex";
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
        setTimeout(() => {
          document.querySelectorAll(".js-update").forEach(function (script) {
            eval(script.innerHTML);
            eval(script.innerText);
          })
          if (typeof globalPop != "undefined") {
            globalPop.time = 0;
            globalPop.run();
          }
        }, 1000);
      }).catch((err) => {
        // Important check any errors here before deploying 

        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));

        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
  }


  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
    }
  });
};
